import { __awaiter } from "tslib";
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePaymentMethodsQuery } from '@websky/graphql';
import { useIsMobile } from '../../../../../utils';
import { useRenderers } from '../../../../../renderProps';
import { usePaymentMethodsError } from '../../../../../PaymentMethodsError/hooks';
import { getLastExchange } from '../../../../../Checkout/store/order/selectors';
import PaymentComponent from '../../../../../Modules/Exchange/components/Exchange/Payment/Payment';
import ErrorModal from '../../../../../PaymentMethodsError';
import { PaymentStatus, setLoading, setPaymentStatus, useExchange } from '@entities/exchange';
import { useRouter } from '@shared/lib/router';
import { FooterMobile } from '@shared/ui';
const Payment = () => {
    const dispatch = useDispatch();
    const lastExchange = useSelector(getLastExchange);
    const isMobile = useIsMobile();
    const router = useRouter();
    const { updateOrder } = useExchange();
    const { data, loading, error } = usePaymentMethodsQuery({
        fetchPolicy: 'no-cache',
        variables: {
            withKaspi: true,
            withItransfer: true,
            withGpay: true,
            withCredit: true,
            withCard: true,
            withQiwi: true,
            withFps: true,
            withSbol: true,
            withPodeli: true,
            withFfpBonus: true,
            parameters: {
                orderId: lastExchange.id,
                backRedirectUrl: `${router.basePath}/exchange/payment/success`,
                backRedirectUrlOnFail: `${router.basePath}/exchange/payment/failed`
            }
        }
    });
    React.useEffect(() => {
        dispatch(setLoading(loading ? 'all' : 'idle'));
    }, [loading]);
    const onSetPaymentStatus = (status) => () => __awaiter(void 0, void 0, void 0, function* () {
        yield updateOrder();
        dispatch(setPaymentStatus(status));
    });
    const onGoToRequest = () => {
        router.navigate('/exchange/request');
    };
    const paymentMethodsErrorModal = usePaymentMethodsError(error);
    const { renderExchangePayment: RenderExchangePaymentOverride = PaymentComponent } = useRenderers();
    if (loading) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(RenderExchangePaymentOverride, { exchangeOrder: lastExchange, paymentMethods: data === null || data === void 0 ? void 0 : data.PaymentMethods, successPayment: onSetPaymentStatus(PaymentStatus.Success), failedPayment: onSetPaymentStatus(PaymentStatus.Failed), goToOrder: onGoToRequest }),
        isMobile && React.createElement(FooterMobile, { onBack: onGoToRequest }),
        React.createElement(ErrorModal, { open: paymentMethodsErrorModal.isOpen, error: paymentMethodsErrorModal.errorMessage, onClose: paymentMethodsErrorModal.close })));
};
export default Payment;
